import type { MobileOfficeConfigurationMobileOfficeConfigurationDto } from '@ori/mobile-office-api-client-react';

export function getFullNameFormat(
  configuration: MobileOfficeConfigurationMobileOfficeConfigurationDto | undefined,
): string {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- in this case its preffered
  return configuration?.customerConfiguration?.fullNameFormat || '{LastName} {FirstName}';
}
